import React, { useEffect, useState } from "react";
import "./ProductEntry.scss";
import DynaDatePicker from "../../../A13/DynaView/DynaDatePicker";
import DynaSelectBox from "../../../A13/DynaView/DynaSelectBox";
import DynaInput from "../../../A13/DynaView/DynaInput";
import CalculationModal from "./CalculationModal/CalculationModal";
import LinedTitle from "../../LinedTitle/LinedTitle";
import _axios from "../../../../httpService";
import { prefixUrl } from "../../../../utils/utilsData";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../../Loader";
import UtilsFunctions from "../../../../utils/UtilsFunctions";

const ProductEntry = () => {
  const navigateTo = useNavigate();
  const myLocation = useLocation();

  const [showModal, setShowModal] = useState(false);
  const [cartonsList, setCartonsList] = useState([]);
  const [farmsList, setFarmsList] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [sellersList, setSellersList] = useState([]);
  const [getInitialDataStatus, setGetInitialDataStatus] = useState(false);
  const [isLoad, setIsLoad] = useState(false);

  const [sendData, setSendData] = useState({
    mode: "add",
    date: "",
    id_kala: "",
    id_farm: "",
    te: "",
    fi: "",
    id_seller: "",
    weight: "",
    vahed: "",
  });

  const fetchInitialData = async () => {
    try {
      const response = await _axios.get(
        prefixUrl() + "/cheeka/?request=productInletInitialData"
      );
      if (response?.data?.status) {
        const { cartonsList, farmsList, productsList, sellersList } =
          response.data.data;
        setCartonsList(cartonsList || []);
        setFarmsList(farmsList || []);
        setProductsList(productsList || []);
        setSellersList(sellersList || []);
        setGetInitialDataStatus(true);
        if (myLocation?.state?.mode !== "edit") setIsLoad(true);
      } else {
        toast.error(response.data.message || "خطا در دریافت اطلاعات اولیه");
      }
    } catch (err) {
      toast.error("خطا در ارتباط با سرور");
    }
  };

  const getEditModeData = async () => {
    try {
      const response = await _axios.get(
        `${prefixUrl()}/cheeka/?request=productInputSubmittedData&record_id=${
          myLocation?.state?.id
        }`
      );
      if (response?.data?.status) {
        setSendData((prev) => ({
          ...prev,
          ...response.data.data,
          mode: "edit",
        }));
        setIsLoad(true);
      } else {
        toast.error(response.data.message);
      }
    } catch (err) {
      toast.error("خطا در دریافت اطلاعات ویرایش");
    }
  };

  useEffect(() => {
    fetchInitialData();
  }, []);

  useEffect(() => {
    if (myLocation?.state?.mode === "edit" && getInitialDataStatus) {
      getEditModeData();
    }
  }, [getInitialDataStatus, myLocation?.state?.mode]);

  const selectedProduct = productsList.find(
    (p) => p.value === sendData.id_kala
  );
  const isWeightBased = selectedProduct?.vahed === "weight";
  const isNumberBased = selectedProduct?.vahed === "number";

  const validateForm = () => {
    if (!sendData.date) return toast.error("تاریخ ورود را انتخاب کنید."), false;
    if (!sendData.id_kala) return toast.error("کالا را انتخاب کنید."), false;
    if (!sendData.id_farm) return toast.error("فارم را انتخاب کنید."), false;
    if (!sendData.fi || Number(sendData.fi) === 0)
      return toast.error("قیمت کالا را وارد کنید."), false;
    if (!sendData.id_seller)
      return toast.error("فروشنده را انتخاب کنید."), false;

    if (isWeightBased && (!sendData.weight || Number(sendData.weight) === 0)) {
      return toast.error("وزن کالا را وارد کنید."), false;
    }

    if (isNumberBased && (!sendData.te || Number(sendData.te) === 0)) {
      return toast.error("تعداد کالا را محاسبه و وارد کنید."), false;
    }

    return true;
  };

  const handleSubmit = () => {
    const postProductRequest = _axios
      .post(prefixUrl() + "/cheeka/?request=submitProductInput", sendData)
      .then((res) => {
        if (res.data.status) {
          toast.success(res.data.message);
          navigateTo(-1);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((error) => console.log(error));

    toast.promise(postProductRequest, {
      pending: "در حال ارسال اطلاعات...",
    });
  };

  return !isLoad ? (
    <Loader />
  ) : (
    <>
      <section className="product__entry">
        <div className="content__section">
          <LinedTitle title="مشخصات کالا" />

          <div className="grid__section">
            <DynaDatePicker
              label="تاریخ ورود"
              name="entryDate"
              className="solid-dyna-input"
              value={sendData.date}
              setDataFromComponent={(data) =>
                setSendData({ ...sendData, date: data?.entryDate })
              }
            />
            <DynaSelectBox
              options={productsList}
              hasFilter={false}
              label="انتخاب کالا"
              className="solid-dyna-input"
              value={sendData.id_kala}
              onChange={(data) => {
                const selected = productsList.find(
                  (p) => p.value === data?.value
                );
                setSendData({
                  ...sendData,
                  id_kala: data?.value,
                  vahed: selected?.vahed,
                });
              }}
            />
            <DynaSelectBox
              options={farmsList}
              hasFilter={false}
              label="انتخاب فارم"
              className="solid-dyna-input"
              value={sendData.id_farm}
              onChange={(data) =>
                setSendData({ ...sendData, id_farm: data?.value })
              }
            />
            <DynaInput
              label="قیمت کالا (تومان)"
              name="fi"
              className="solid-dyna-input"
              placeholder="قیمت کالا را وارد کنید"
              value={UtilsFunctions.addCommas(sendData.fi || "")}
              type="text"
              hasComma={true}
              setDataFromComponent={(data) =>
                setSendData({ ...sendData, ...data })
              }
            />
            <DynaSelectBox
              options={sellersList}
              hasFilter={false}
              label="انتخاب فروشنده"
              className="solid-dyna-input"
              value={sendData.id_seller}
              onChange={(data) =>
                setSendData({ ...sendData, id_seller: data?.value })
              }
            />
            <DynaInput
              label={"وزن کالا"}
              name="weight"
              className="solid-dyna-input"
              placeholder={"وزن کالا را وارد کنید"}
              value={UtilsFunctions.addCommas(sendData.weight || "")}
              type="text"
              hasComma={true}
              setDataFromComponent={(data) =>
                setSendData({ ...sendData, ...data })
              }
            />
            {isNumberBased && (
              <>
                <div className="count__btn__container">
                  <button
                    className="count__btn"
                    onClick={() => setShowModal(true)}
                  >
                    محاسبه تعداد
                  </button>
                </div>
                <div className="total__container">
                  <span>
                    تعداد کل: {UtilsFunctions.addCommas(sendData.te || "0")}
                  </span>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="bottom__section">
          <div className="action__buttons">
            <button onClick={() => navigateTo(-1)} className="cancel__button">
              انصراف
            </button>
            <button
              onClick={() => validateForm() && handleSubmit()}
              className="submit__button"
            >
              {sendData?.mode === "add" ? "ثبت" : "ویرایش"}
            </button>
          </div>
        </div>
      </section>

      {showModal && (
        <CalculationModal
          onClose={() => setShowModal(false)}
          data={cartonsList}
          onSubmit={(totalValue) =>
            setSendData((prev) => ({ ...prev, te: totalValue.toString() }))
          }
        />
      )}
    </>
  );
};

export default ProductEntry;
